import React from "react";

type TProps = {
  input: any;
  register: any;
}

function Checkbox({input, register}: TProps) {
  return (
    <div className="checkboxes-block">
      {input.values.map((item: any, key: number) => {
        return (
          <div className="checkbox-field flex mb-2" key={key}>
            <input
              type="checkbox"
              value={item.value}
              {...register(input?.name || '', { required: input?.required })}
            />
            <div className="checkbox-name pl-2">{item.value}</div>
          </div>
        )
      })}
    </div>
  )
}

export default Checkbox;
